import { useState } from 'react';
import { ITipoVeiculoResponse, tiposVeiculosService } from './services';
import Swal from 'sweetalert2';
import { Form, Select, message } from 'antd';
import TextFilter from '../../../components/TextFilter';
import mask from '../../../utils/mask';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';

export const SelectTipoVeiculo: React.FC = () => {
  const { Option } = Select;
  const parceiros = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const [response, setResponse] = useState<ITipoVeiculoResponse | undefined>();

  function handleTipoVeiculoRequest(): void {
    if (parceiros.length === 0) {
      message.warning('Selecione um parceiro para ter acesso a lista de tipos de veículos!');
      return;
    }

    if (localStorage.getItem(`responseTiposVeiculosFilter${window.location.pathname}`)) {
      const tiposVeiculos = JSON.parse(
        localStorage.getItem(`responseTiposVeiculosFilter${window.location.pathname}`) || '{}'
      );
      setResponse(tiposVeiculos);
      return;
    }

    try {
      tiposVeiculosService.getTiposCarroceria().then((res) => {
        setResponse(res.data);
        localStorage.setItem(
          `responseTiposVeiculosFilter${window.location.pathname}`,
          JSON.stringify(res.data)
        );
      });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar os tipos de veículos, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
      });
    }
  }

  return (
    <Form.Item label={<TextFilter>Tipo veículo</TextFilter>} name="codTipoVeiculo">
      <Select
        filterOption={(inputValue, element) =>
          element?.props.children
            ?.toString()
            ?.toLowerCase()
            ?.replace(/\.|-/g, '')
            ?.includes(inputValue.toLowerCase())
        }
        showSearch
        onFocus={handleTipoVeiculoRequest}
        placeholder="Selecione o tipo de veículo"
      >
        {response ? (
          response?.tiposVeiculos?.map((tipoVeiculo) => (
            <Option value={tipoVeiculo.codTip} key={tipoVeiculo.codTip}>
              {mask('camelCase', tipoVeiculo.nome)}
            </Option>
          ))
        ) : (
          <Option value={-1}>Carregando...</Option>
        )}
      </Select>
    </Form.Item>
  );
};
